import React, { useEffect } from 'react';
import { withPage } from '@sms/plasma-ui';
import { getUserFromLocalStorage } from '../utils/oidc';

const RootPage: React.FC = () => {
  const envVars: Record<string, unknown> = typeof window === "undefined" ? process.env
    : (window as any).plasma.environment

  const vero = `${envVars.VERO_API_URL}plasma/validate`
  const webgee = `${envVars.WEBGEE_API_URL}configuracoes/usuarios/minhas-permissoes`

  useEffect(() => {
    const user = getUserFromLocalStorage();
    const access_token = user?.access_token;
    const id_token = user?.id_token;

    if (id_token && access_token) {
      fetch(vero, {
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${access_token}`
        }
      })
        .then(response => {
          if (!response.ok) throw new Error('Failed to fetch vero');
          return response.json();
        })
        .then(data => { })
        .catch(error => {
          console.error('Error fetching vero:', error);
        });

      fetch(webgee, {
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${access_token}`
        }
      })
        .then(response => {
          if (!response.ok) throw new Error('Failed to fetch webgee');
          return response.json();
        })
        .then(data => { })
        .catch(error => {
          console.error('Error fetching webgee:', error);
        });
    }
  }, []);

  return <></>;
};

export default withPage(RootPage);
